<template>
<div>
    <title>{{ $t('feedback.text_0') }} - DOFFERO®</title>
    <div class="title">
        <under-bar-name :title="$t('feedback.text_0')" :margin="false"></under-bar-name>
    </div>
    <div class="cont">
        <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.1/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-+0n0xVW2eSR5OomGNYDnhzAbDsOXxcvSN1TPprVMTNDbiYZCxYbOOl7+AMvyTG2x" crossorigin="anonymous">
        <h1>{{ $t('feedback.text_1') }}</h1>
        <h3>
            {{ $t('feedback.text_2') }}
        </h3>
        <div class="main">
            <p class="text-center">{{ $t('feedback.text_3') }}</p>
            <div class="one mt-2">
                <div class="form-floating">
                    <input  
                        type="text" 
                        class="form-control" 
                        id="floatingInput" 
                        :placeholder="$t('feedback.text_4')"
                        v-model="tel"
                    />
                    <label for="floatingInput">{{ $t('feedback.text_4') }}</label>
                </div>
            </div>
            <div class="one mt-4">
                <div class="form-floating">
                    <input  
                        type="text" 
                        class="form-control" 
                        id="floatingInput" 
                        :placeholder="$t('feedback.text_5')"
                        v-model="email"
                    />
                    <label for="floatingInput">{{ $t('feedback.text_5') }}</label>
                </div>
            </div> 
            <div class="one mt-4" style="height: 177px">
                <div class="form-floating">
                    <textarea 
                        v-model="text" 
                        class="form-control" 
                        :placeholder="$t('feedback.text_6')" 
                        id="floatingTextarea2" 
                        style="height: 177px">
                    </textarea>
                    <label for="floatingInput">{{ $t('feedback.text_6') }}</label>
                </div>
            </div> 
            <form action="" method="post" enctype="multipart/form-data" class="feedback_file mt-4" >
                <input type="file" name="files" ref="file" class="files" multiple/>
            </form>
            <div class="ulozit" @click="send">
                <span v-show="!send_btn">{{ $t('feedback.text_7') }}</span>
                <div v-show="send_btn" class=" lds-ellipsis">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            tel: "",
            email: "",
            text: "",
            file: null,
            send_btn: false
        }
    },
    methods: {
        send(){
            if(this.text == "" ){
                this.$toast.warning(this.$t('feedback.text_8'), { timeout: 5000, });
                return;
            }
            const fd = new FormData();
            fd.append('file', this.file)
            fd.append('text', this.text)
            fd.append('tel', this.tel)
            fd.append('email', this.email)
            this.send_btn = true;
            axios.post(`/api/feedback`, fd).then(response => {
                this.tel= "",
                this.email= "",
                this.text= "",
                this.file= null,
                this.send_btn= false
                $('.fileuploader-items-list').empty();
                this.$toast.success(this.$t('feedback.text_9'), { timeout: 2038, });
            });

        }
    },
    mounted () {
        var t = this
        $(document).ready(function() {
            $.ajaxSetup({
                headers: {
                    "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
                }
            });
            $(".feedback_file input.files").fileuploader({
                limit: 1,
                extensions: ["jpg", "png", "svg", "pdf"],
                fileMaxSize: 3,
                changeInput:
                            '<div class="fileuploader-input">' +
                            '<div class="fileuploader-input-inner">' +
                            '<div class="fileuploader-icon-main"></div>' +
                            '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
                            "<p>${captions.or}</p>" +
                            '<button type="button" class="fileuploader-input-button"><span>${captions.button}</span></button>' +
                            "</div>" +
                            "</div>",
                theme: "dragdrop",
                thumbnails: {
                    onImageLoaded: function(item) {
                        t.file = item.file
                        if (!item.html.find(".fileuploader-action-edit").length)
                            item.html
                                .find(".fileuploader-action-remove")
                                .before(
                                    '<button type="button" class="fileuploader-action fileuploader-action-popup fileuploader-action-edit" title="Uraviť">' +
                                        '<i class="fileuploader-icon-edit"></i></button>'
                                );
                        if (item.imageIsUploading) {
                            item.image.addClass("fileuploader-loading").html("");
                        }
                    },
                },
                editor: {
                    cropper: {
                        showGrid: true
                    }
                },
                captions: $.extend(true, {}, $.fn.fileuploader.languages["en"], {
                    feedback: t.$t('feedback.text_10'),
                    feedback2: t.$t('feedback.text_10'),
                    drop: t.$t('feedback.text_10'),
                    or: t.$t('feedback.text_11'),
                    button: t.$t('feedback.text_12'),
                    remove: t.$t('feedback.text_13'),
                    download: t.$t('feedback.text_14'),
                    removeConfirmation: t.$t('feedback.text_15'),
                    errors: {
                        filesLimit: function(e) {
                            t.$toast.warning(t.$t('feedback.text_16'), { timeout: 5000 });
                        },
                        filesType: function(e) {
                            t.$toast.warning(t.$t('feedback.text_17', { extensions: e.extensions }), { timeout: 5000 });
                        },
                        fileSize: function(e) {
                            t.$toast.warning(
                                t.$t('feedback.text_18', { name: e.name, fileMaxSize: e.fileMaxSize }),
                                { timeout: 5000 }
                            );
                        }
                    }
                }),

                onRemove: function(item) {
                    t.file = null
                },
            });
        })
    },
}
</script>

<style lang="scss" scoped>
    form{
        width: 477px;
        margin: 0 auto;
        @media only screen and (max-width: 600px) {
            width: 95%;
        }
    }
    .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 13px;
        height: 13px;
        border-radius: 50%;
        background: #fff;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(24px, 0);
        }
    }   
    .title{
       width: 1188px;
       margin: 65px auto 0 auto;
       @media only screen and (max-width: 1500px) {
            width: 95%;
        }
    }
    .cont{
        width: 1188px;
        margin: 50px auto 0 auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
        padding: 57px 0 140px 0;
        @media only screen and (max-width: 1500px) {
            width: 95%;
        }
        h1{
            @media only screen and (max-width: 600px) {
                width: 90%;
                margin: 0 auto;
            }
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 36px;
            line-height: 42px;
            text-align: center;
            color: #2e0808;
        }
        h3{
            width: 753px;
            @media only screen and (max-width: 800px) {
                width: 90%;
            }
            margin: 23px auto 36px auto;
            font-family: Roboto;
            font-style: normal;
            font-weight: 500;
            font-size: 24px;
            line-height: 36px;
            text-align: center;
            color: #9598A7;
        }
        .main{
            width: 1030px;
            margin: 0 auto;
            background: #F2F7FB;
            border-radius: 5px;
            padding: 30px 0 78px 0;
            @media only screen and (max-width: 1500px) {
                width: 90%;
            }
            .one{
                .form-floating{
                    width: 473px;
                    height: 55px;
                    margin: 0 auto;
                    @media only screen and (max-width: 600px) {
                        width: 95%;
                    }
                    textarea{
                        padding-left: 15px;
                    }
                    input{
                        display: flex !important;
                        align-items: center !important;
                        background: #FFFFFF;
                        border: 1px solid #DDE3E8;
                        box-sizing: border-box;
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 14px;
                        line-height: 16px;
                        display: flex;
                        align-items: center;
                        color: #212541;
                    }
                    label{
                        display: flex !important;
                        align-items: center !important;
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 12px;
                        letter-spacing: 0.1em;
                        text-transform: uppercase;
                        color: #9598A7;
                        padding-left: 15px;
                    }
                }
            }
            .ulozit{
                width: 474px;
                height: 55px;
                @media only screen and (max-width: 600px) {
                    width: 95%;
                }
                margin: 47px auto 0 auto;
                background: #2ED8B6;
                border-radius: 4px;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 16px;
                line-height: 19px;
                display: flex;
                align-items: center;
                text-align: center;
                justify-content: center;
                color: #FFFFFF;
                cursor: pointer;
                transition: .5s all;
                &:hover{
                    background: #23caa9;
                }
            }

        }
    }
</style>